import { getAgentNif } from '../../functions';


const env = process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV;

let authority;
let redirectUri;

switch (env) {
  case "production":
    authority = 'https://divina-identity-api.divinapastora.com';
    redirectUri = 'https://quote-correduria.divinapastora.com'; 
    break;
  case "staging":
    authority = 'https://divina-identity-stg-api.divinapastora.com';
    redirectUri = 'https://quote-correduria-stg.divinapastora.com'; 
    break;
  default:
    authority = 'https://divina-identity-stg-api.divinapastora.com';
    redirectUri = 'http://localhost:3000'; 
    break;
}

const oidcConfig = {
  onSignIn: async (user) => {
    window.location.hash = '';
    var uri = window.location.toString();
    if (uri.indexOf("?") > 0) {
        var clean_uri = uri.substring(0, uri.indexOf("?"));
        window.history.replaceState({}, document.title, clean_uri);
    }
  },
  authority,
  redirectUri,
  clientId: 'quote-correduria',
  responseType: 'code',
  loginHint: getAgentNif(),
};

export default oidcConfig;



// WEBPACK FOOTER //
// ./src/utils/auth/oidcConfig.js